<template>
    <VJoyButton
        v-if="hasLocale"
        variant="ghost"
        size="small"
        data-testid="locale-selection-button"
        class="locale-selection-button"
        :aria-label="$t('navbar.feat.locale-selection.dialog.cta.open')"
        :class="{'has-locale': hasLocale}"
        :disabled="props.loading"
    >
        <div class="locale-selection-button__content">
            <VJoyIcon size="small" :name="iconName" />
            {{ props.locale }}
        </div>
    </VJoyButton>
    <VJoyIconButton
        v-else
        variant="ghost"
        size="small"
        data-testid="locale-selection-button"
        class="locale-selection-button"
        :aria-label="$t('navbar.feat.locale-selection.dialog.cta.open')"
        :disabled="props.loading"
        :icon="iconName"
    />
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {useMouseHover} from '@malt/utils';
    import {VJoyButton, VJoyIcon, VJoyIconButton} from '@maltjoy/core-vue';

    const props = defineProps<{
        loading?: boolean;
        locale?: string;
    }>();

    // Composables
    const {isHovering} = useMouseHover();

    // Computed values
    const hasLocale = computed(() => !!props.locale);
    const iconName = computed(() => (isHovering.value ? 'globe-hover' : 'globe'));
</script>
<style lang="scss" scoped>
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/text' as text;

    .locale-selection-button {
        &.has-locale {
            border-radius: var(--joy-form-field-radius-xxsmall) !important;
            padding: var(--button-padding, 0 var(--joy-core-spacing-3)) !important;
        }

        &,
        * {
            @include text.getFontBySize(primary-400);

            color: var(--joy-color-neutral-60);
        }

        .locale-selection-button__content {
            display: flex !important;
            align-items: center;
            justify-content: center;
            gap: var(--joy-core-spacing-2);
        }
    }
</style>
